import React from 'react';
import { MainView, RecContainer } from '../components/components.js';

class Recommendations extends React.Component {

	constructor(props) {
		super(props);

		this.getRecs = this.getRecs.bind(this);
		this.getRecContent = this.getRecContent.bind(this);

		this.state = {
			recommendations : false
		};
	}

	componentDidMount() {

		if(this.state.recommendations === false) {
			this.getRecs();
		}
	}

	getRecs() {
		var comp = this;

		var callback = function(response) {
			console.log(response);
			if(response.code === 200) {
				comp.setState({
					recommendations : response.data
				});
			}
		};

		window._fiSponsor.GET_RECOMMENDATIONS(callback);
	}

	getRecContent() {
		var recContent = (<div className="App-LoadContainer"><div className="App-Loader recommendations"></div><div className="Loading">Gathering recommendations...</div></div>);

		if(this.state.recommendations !== false) {

			if(Object.keys(this.state.recommendations).length === 0) {
				return (<div className="Error">We don't have any recommendations for today.<br/><br/>Reach out to our team at support@plinqit.com if you have any questions or concerns.</div>);
			}


			recContent = [];

			var recs = ['credit', 'checking', 'mortgage']; //This order  matters for now
			var noMortgageIds = ['3', '4ebe7405-cb40-4769-94a9-2b839dabc15e']; //FAB&T
			if(noMortgageIds.includes(window._fiSponsor.sponsors[0].id) === true) {
				recs.splice(recs.indexOf('mortgage'), 1);
			}

			for(var cKey in recs) {
				if(Object.keys(this.state.recommendations).indexOf(recs[cKey]) > - 1) {
					recContent.push((
						<RecContainer
							type={recs[cKey]}
							title={recs[cKey].charAt(0).toUpperCase() + recs[cKey].slice(1)}
						/>
						));
				}
			}
		}

		return recContent;
	}

	render() {
		var location = 'Recommendations';

		window._fiSponsor.loadSessionInfo();

		var reccontent = this.getRecContent();

		var content = (
			<div>
				<div className="Rec-Header">
					Plinqit has created lists of users who may benefit from a product {window._fiSponsor.sponsors[0].name} is focusing on based upon your strategic goals.<br/>
				</div>
				<div className="Rec-Main-View">
					{reccontent}
				</div>
			</div>
		);

		return (
		    <MainView location={location} amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
		);
	}
}

export default Recommendations;